import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiSettings, FiDatabase, FiBookOpen } = FiIcons;

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <motion.header
      className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            {/* Logo: Rot zu Schwarz Verlauf */}
            <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-black rounded-lg flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-lg">Z</span>
            </div>
            <div>
              <h1 className="text-2xl font-bold gradient-text">Zeak</h1>
              <p className="text-sm text-gray-600">Materialdatenbank</p>
            </div>
          </Link>

          <div className="flex-1 max-w-2xl mx-8">
            <form onSubmit={handleSearch} className="relative">
              <SafeIcon 
                icon={FiSearch} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" 
              />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Artikelnummer, Hersteller oder Spezifikation suchen..."
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
              />
            </form>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/categories"
              className="flex items-center space-x-2 p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiDatabase} className="w-5 h-5" />
              <span className="hidden md:block">Kategorien</span>
            </Link>
            <Link
              to="/technical-docs"
              className="flex items-center space-x-2 p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiBookOpen} className="w-5 h-5" />
              <span className="hidden md:block">Technische Daten</span>
            </Link>
            <button className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-lg transition-colors">
              <SafeIcon icon={FiSettings} className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;